import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const Price = styled('div')`
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 14px;
  line-height: 125%;
  color: ${theme.palette.secondary.main};

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 8px;
    margin-bottom: 12px;
  }

  &.big {
    font-size: 16px;
    color: ${theme.palette.text.dark};
  }

  .MuiFormControl-root {
    width: 200px;

    @media (max-width: ${theme.breakpoints.values.sm}px) {
      width: 100%;
    }
  }
`;
